import Loading from '../../../Common/Loading';
import { useAPHChartsDataContext } from './hooks/useAPHChartsDataContext';
import { OcurrenceListByAPHType } from './OcurrenceListByAPHType';
import './styles/Charts.css';

export const Charts = () => {
    const { isLoading } = useAPHChartsDataContext();

    if (isLoading) {
        return <Loading />;
    }

    return (
        <>
            <OcurrenceListByAPHType />
        </>
    );
};
